<!-- 상단 고정 FOMO 배너 -->
<div class="fomo-top-banner">
  <div class="fomo-top-inner">
    <!-- 좌측 아이콘 + 텍스트 -->
    <div class="fomo-top-content">
      <span class="fomo-pulse-dot"></span>
      <span class="fomo-label">
        현재
        <span class="fomo-count" [class.animating]="isAnimating()">
          {{ count() }}
        </span>
        명이 PigBank와 함께하고 있습니다
      </span>
    </div>

    <!-- 우측 뱃지 -->
    <div class="fomo-badge">
      <span class="icon-[material-symbols--bolt]"></span>
      실시간
    </div>
  </div>
</div>
